import { motion } from 'framer-motion';

import { Icon } from '@/new/components/icon';

export enum View {
  Upload = 'upload',
  Explorer = 'explorer',
}

interface ViewToggleProps {
  view: View;
  setView: (view: View) => void;
}

export const ViewToggle = ({ view, setView }: ViewToggleProps) => {
  return (
    <div className="flex w-fit rounded-md bg-gray-100 p-1">
      <motion.button
        onClick={() => setView(View.Upload)}
        className={`relative flex items-center gap-2 rounded-md px-3 py-1.5 text-sm transition-all ${
          view === View.Upload ? 'text-brandSecondary bg-white shadow-sm' : 'text-gray-600 hover:text-gray-900'
        }`}
        animate={{
          x: view === View.Upload ? 0 : 0,
          scale: view === View.Upload ? 1.02 : 1,
        }}
        transition={{ type: 'spring', stiffness: 400, damping: 40 }}
      >
        <Icon className="lucide--folder-plus" />
        <span>Upload</span>
      </motion.button>
      <motion.button
        onClick={() => setView(View.Explorer)}
        className={`relative flex items-center gap-2 rounded-md px-3 py-1.5 text-sm transition-all ${
          view === View.Explorer ? 'text-brandSecondary bg-white shadow-sm' : 'text-gray-600 hover:text-gray-900'
        }`}
        animate={{
          x: view === View.Explorer ? 0 : 0,
          scale: view === View.Explorer ? 1.02 : 1,
        }}
        transition={{ type: 'spring', stiffness: 400, damping: 40 }}
      >
        <Icon className="lucide--list" />
        <span>Files</span>
      </motion.button>
    </div>
  );
};
